const DATA_SAVED = "extragestor/listados/DATA_SAVED";
const RESET_DATA_SAVED = "extragestor/listados/RESET_DATA_SAVED";
const FETCH_LISTADO_BAJAS = "extragestor/listados/FETCH_LISTADO_BAJAS";
const RESET_LISTADO_BAJAS = "extragestor/listados/RESET_LISTADO_BAJAS";

/*---*/
export {
  DATA_SAVED,
  RESET_DATA_SAVED,
  FETCH_LISTADO_BAJAS,
  RESET_LISTADO_BAJAS
};



// WEBPACK FOOTER //
// ./src/ducks/listados/types.js